import { useState, useEffect, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
    UserSession,
    AdminUser
  } from '../utils'
import ThemeOption from '../components/ThemeOption'
import { Client, Account } from "appwrite";
import DashboardMenu from '../components/DashboardMenu'
import { storage } from '../appwrite/config'

import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Multiselect from '../components/Multiselect'
import LogoLoader from '../components/LogoLoader';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';


const client = new Client()
  .setEndpoint(process.env.REACT_APP_ENDPOINT)
  .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);


export default function NotFound() {
  const navigate = useNavigate()
  const [userSession, setUserSession] = useAtom(UserSession);


  // Set authenticated session on initial page load
  useEffect(() => {
    const checkSession = async () => {
      try {
        const user = await account.get()
        return user
      } catch (error) {
        navigate('/')
      }
    }
    setUserSession(checkSession())
  }, []);

  return (<>
    <DashboardMenu path="" user={userSession} page={<Stack className="page-content" alignItems="center" justifyContent="center" gap={2} sx={{ height: '85vh' }}>
      <Typography variant="h2" gutterBottom>404 Page Not Found</Typography>
      <Typography variant="h4" sx={{ color: 'text.secondary' }}>Hmm, this page doesn't exist.</Typography>
    </Stack>} />
  </>)
}